import { render, staticRenderFns } from "./task_rule_add.vue?vue&type=template&id=c084b9e6&"
import script from "./task_rule_add.vue?vue&type=script&lang=js&"
export * from "./task_rule_add.vue?vue&type=script&lang=js&"
import style0 from "./task_rule_add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports